import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=1340bd42&scoped=true&"
import script from "./video-player.vue?vue&type=script&lang=js&"
export * from "./video-player.vue?vue&type=script&lang=js&"
import style0 from "./video-player.vue?vue&type=style&index=0&id=1340bd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340bd42",
  null
  
)

export default component.exports